import React from 'react';
import { Heart } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If not on homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/logo.svg" alt="House of Microgreens" className="footer-logo" />
            <p className="footer-text">Fresh, nutritious microgreens delivered weekly to your doorstep.</p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('benefits')} className="footer-link">Benefits</button></li>
              <li><button onClick={() => scrollToSection('subscription')} className="footer-link">Subscription</button></li>
              <li><button onClick={() => scrollToSection('varieties')} className="footer-link">Varieties</button></li>
              <li><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><button onClick={() => scrollToSection('about')} className="footer-link">About Us</button></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('faq')} className="footer-link">FAQ</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms-conditions" target="_blank" rel="noopener noreferrer" className="footer-link">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/shipping-delivery" target="_blank" rel="noopener noreferrer" className="footer-link">Shipping & Delivery</Link></li>
              <li><Link to="/cancellation-refund" target="_blank" rel="noopener noreferrer" className="footer-link">Cancellation & Refund</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} House of Microgreens. All rights reserved.
          </p>
          <p className="footer-made-with">
            Made with <Heart size={16} fill="var(--accent-primary)" stroke="var(--accent-primary)" /> for healthy living
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
